<div class="pt30 pb30 pop_dialog" style="background:#ffffff;">
    <div class="swal2-icon swal2-warning pulse-warning text-center line-height50">
        <div class="font50 pt15">x</div>
    </div>
    <h2 align="center" class="font20 font500">{{dialogData.BodyText}}</h2>
    <div align="center">
        <button mat-button (click)="onCloseConfirm()" class="swal2-confirm btn btn-danger">OK</button>
    </div>
</div>